import React from 'react'

import { useQueryGetUserLogged } from '@flecto/core/shared'
import GenerateCloudflareUrl from '@flecto/utils/src/Strings/generateCloudflareUrl'

export function useUserAvatar() {
  const { data } = useQueryGetUserLogged()

  const avatar = React.useMemo(() => {
    if (data?.links.avatar_url) {
      return GenerateCloudflareUrl(data.links.avatar_url)
    }

    return null
  }, [data])

  return { avatar }
}
